
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Phone, Mail, Image, Wrench } from 'lucide-react';
import { motion } from 'framer-motion';

const MobileNavBar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Check on initial load
    checkMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkMobile);
    
    // Clean up
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (!isMobile) return null;
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <>
      <motion.div 
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-1 py-2 z-40 shadow-lg"
      >
        {/* Navigation Icons */}
        <div className="flex justify-around items-center">
          <Link to="/" className={`flex flex-col items-center p-1 ${isActive('/') ? 'text-blue-600' : 'text-gray-600'}`}>
            <div className={`p-1.5 rounded-full ${isActive('/') ? 'bg-blue-100' : ''} transition-colors`}>
              <Home size={20} className={isActive('/') ? "text-blue-600" : "text-gray-600"} />
            </div>
            <span className="text-xs mt-0.5">Home</span>
          </Link>
          
          <Link to="/services" className={`flex flex-col items-center p-1 ${isActive('/services') ? 'text-blue-600' : 'text-gray-600'}`}>
            <div className={`p-1.5 rounded-full ${isActive('/services') ? 'bg-blue-100' : ''} transition-colors`}>
              <Wrench 
                size={20} 
                className={isActive('/services') ? "text-blue-600" : "text-gray-600"} 
              />
            </div>
            <span className="text-xs mt-0.5">Services</span>
          </Link>
          
          <Link to="/portfolio" className={`flex flex-col items-center p-1 ${isActive('/portfolio') ? 'text-blue-600' : 'text-gray-600'}`}>
            <div className={`p-1.5 rounded-full ${isActive('/portfolio') ? 'bg-blue-100' : ''} transition-colors`}>
              <Image 
                size={20} 
                className={isActive('/projects') ? "text-blue-600" : "text-gray-600"}  
              />
            </div>
            <span className="text-xs mt-0.5">Portfolio</span>
          </Link>
          
          <Link to="/contact" className={`flex flex-col items-center p-1 ${isActive('/contact') ? 'text-blue-600' : 'text-gray-600'}`}>
            <div className={`p-1.5 rounded-full ${isActive('/contact') ? 'bg-blue-100' : ''} transition-colors`}>
              <Phone 
                size={20} 
                className={isActive('/contact') ? "text-blue-600" : "text-gray-600"} 
              />
            </div>
            <span className="text-xs mt-0.5">Contact</span>
          </Link>
          
          <Link to="/quote" className={`flex flex-col items-center p-1 ${isActive('/quote') ? 'text-blue-600' : 'text-gray-600'}`}>
            <div className={`p-1.5 rounded-full ${isActive('/quote') ? 'bg-blue-100' : ''} transition-colors`}>
              <Mail 
                size={20} 
                className={isActive('/quote') ? "text-blue-600" : "text-gray-600"} 
              />
            </div>
            <span className="text-xs mt-0.5">Quote</span>
          </Link>
        </div>
      </motion.div>
      
      {/* Add spacing at the bottom of the page to prevent content from being hidden by the nav bar */}
      <div className="block md:hidden h-16"></div>
    </>
  );
};

export default MobileNavBar;
